import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import api from '../services/api';

const StoreContext = createContext();

export const StoreProvider = ({ children }) => {
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  // Cargar tiendas cuando cambia el usuario
  useEffect(() => {
    if (user) {
      loadStores();
    } else {
      // limpiar estado al logout
      setStores([]);
      setSelectedStore(null);
      localStorage.removeItem('selectedStore');
    }
  }, [user]);

  const loadStores = async () => {
    try {
      setLoading(true);
    
      const endpoint =
        user.role === 'admin'
          ? '/stores'
          : `/users/${user.id}/stores`;
    
      console.log('🏪 Loading stores for:', user.role, 'Endpoint:', endpoint);
      
      const response = await api.get(endpoint);
      const data = response.data;
    
      console.log('📦 Stores response:', data);
    
      if (!data.success) {
        console.warn('⚠️ Stores API returned success: false');
        return;
      }
    
      const storesList = data.data;
      console.log('✅ Stores loaded:', storesList.length, 'stores');
      setStores(storesList);
    
      if (user.role === 'employee' && storesList.length === 1) {
        console.log('👤 Employee with 1 store - auto-selecting');
        setSelectedStore(storesList[0]);
        localStorage.setItem('selectedStore', storesList[0].id.toString());
        return;
      }
    
      const savedStoreId = localStorage.getItem('selectedStore');
      if (savedStoreId) {
        const savedStore = storesList.find(
          s => s.id === Number(savedStoreId)
        );
        if (savedStore) {
          console.log('💾 Restored saved store:', savedStore.name);
          setSelectedStore(savedStore);
          return;
        }
      }
    
      const defaultStore = storesList[0] || null;
      console.log('🎯 Setting default store:', defaultStore?.name || 'none');
      setSelectedStore(defaultStore);
      if (defaultStore) {
        localStorage.setItem('selectedStore', defaultStore.id.toString());
      } else {
        localStorage.removeItem('selectedStore');
      }
    
    } catch (error) {
      console.error('❌ Error loading stores:', error);
      console.error('Error details:', error.response?.data || error.message);
    } finally {
      setLoading(false);
    }
  };

  const changeStore = (store) => {
    // 🔐 Bloquear SOLO si es employee con 1 tienda
    if (user.role === 'employee' && stores.length === 1) {
      return;
    }

    setSelectedStore(store);
    localStorage.setItem('selectedStore', store.id.toString());

    // Notificar cambio global
    window.dispatchEvent(
      new CustomEvent('storeChanged', { detail: store })
    );
  };

  return (
    <StoreContext.Provider
      value={{
        stores,
        selectedStore,
        changeStore,
        loading,
        refreshStores: loadStores
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error('useStore must be used within a StoreProvider');
  }
  return context;
};